const anyDefaultConstants = {
  defaultCourseIds: [
    44,
    49,
    50,
    51,
    53,
    55,
    56,
    62,
    82,
    103,
    122,
    124,
    125,
    139,
    159,
    162,
    172,
    174,
    177,
    183,
    185,
    194,
    219,
    223,
    230,
    243,
    257,
    276,
    277,
    279,
    282,
    302,
    320,
    324,
    326,
    328,
    329,
    332,
    336,
    337,
    338,
    344,
    345,
    346,
    349,
    360,
    364,
    373,
    377,
    313,
    237,
    311,
    133,
    140,
    160,
    171,
    196,
    201,
    216,
    228,
    197,
    200,
    213,
    218,
    288,
    327,
    339,
    318,
    316,
    312,
    305,
    304,
    386,
    317,
    38,
    303,
    73
  ],
  defaultRecommendedCourseIds: [62, 171, 172, 56, 174, 337, 122],
  defaultNewCourseIds: [377, 386, 177, 364, 327],
  defaultTopSaleCourseIds: [277, 174, 172, 73, 257, 53, 171],
  defaultSpecialCourseId: 388, // Id course on PROD
  defaultSpecialStartDate: 1763586000000, // 20.11.25 00:00:00
  defaultSpecialCourseIdSecond: 385, // Id course on PROD
  defaultSpecialStartDateSecond: 1764943200000, // 05.12.25 17:00:00
  defaultSpecialCourseIdsInSubscription: [306, 391], // Ids course on PROD in subscription
  defaultSpecialCourseIdsBundle: [62, 171, 172, 277], // Ids course on PROD bundle
  defaultSpecialCourseIdForClub: 188, // Id course on PROD for club
  defaultSpecialClubId: 1, // Id club on PROD
  defaultPaywallServiceId: 3012 // Id service on PROD in paywall
}

export default anyDefaultConstants
